import React, { useState, useEffect, useContext, Fragment } from "react";
import {
  Typography,
  Card,
  makeStyles,
  List,
  ListItem,
  Grid,
  Button,
  Collapse,
  CircularProgress,
} from "@material-ui/core";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { FaCircle, FaCaretDown, FaCaretUp, FaSort } from "react-icons/fa";
import TableData from "./TableData";
import { LangContext } from "../../Context/Langcontext";
import Tooltips from "@material-ui/core/Tooltip";
import { ServiceContext } from "../../Context/ServiceContext";
import { UserContext } from "../../Context/UserContext";
import { APIContext } from "../../Context/APIContext";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    overflowY: "auto",
    maxHeight: "20rem",
    minHeight: "100%",
  },
  btnstyle: {
    borderRadius: 8,
    padding: "0.3rem 2.25rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "transparent",
    color: "#E16733",
  },
  grid: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
  },
  icon: {
    fontSize: "1.5rem",
    color: "#E16733",
  },
  search: {
    // [theme.breakpoints.down("sm")]: {
    //   margin: "0rem",
    // },
    // [theme.breakpoints.up("md")]: {
    //   margin: "2rem 0rem",
    // },
  },
  nosearch: {
    margin: "2rem",
  },
  cardtooltip: {
    margin: "1rem",
    display: "flex",
    width: "100%",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#ffffff87",
    borderRadius: 8,
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    maxHeight: 360,
    overflowY: "auto",
  },
  fonttooltip: {
    fontSize: "0.7rem",
    fontWeight: 400,
    color: "#595A5A",
  },
  fontlabel: {
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#595A5A",
  },
  cardnote: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    // alignItems: "center",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    overflowY: "auto",
    maxHeight: "20rem",
    minHeight: "100%",
  },
  listname: {
    fontWeight: 400,
    fontSize: "0.7rem",
  },
  servicetype: {
    fontWeight: 400,
  },
}));

const Linechartapi = ({ type, size, data, sum, loading, setloading }) => {
  const classes = useStyle();
  const [expand, setExpand] = useState(false);
  const [fetch, setfetch] = useState(false);
  const langContext = useContext(LangContext);
  const serviceContext = useContext(ServiceContext);
  const userContext = useContext(UserContext);
  const lang = langContext.lang.data;
  const apiContext = useContext(APIContext);
  const errorcomment = [
    { title: "จำนวนเงินในบัญชีไม่เพียงพอในการเรียก service" },
    { title: "Server ในการให้บริการเกิดเหตุขัดข้อง" },
  ];

  let color = [
    "#E16733",
    "#F1B351",
    "#BFC0BF",
    "#93A9C3",
    "#ADCAC8",
    "#e8c5eb",
    "#a1fdb5",
    "#f00d26",
    "#b3faee",
    "#62607d",
    "#74a845",
    "#350284",
    "#c7013f",
    "#d5fdda",
    "#98fb57",
    "#a42d0a",
    "#04ee9c",
    "#90e444",
    "#d88688",
    "#7f7c27",
    "#08726b",
    "#54424c",
    "#3ef48a",
    "#3dabd6",
    "#27f4ec",
    "#760f9b",
    "#875545",
    "#d7c161",
    "#49addd",
    "#03ee15",
    "#f2eb9e",
    "#a6513c",
    "#a3269f",
    "#e484c1",
    "#9ca846",
    "#580b0f",
    "#240604",
    "#892e38",
    "#f6f36e",
    "#e582a7",
    "#7f8061",
    "#809b4f",
    "#b3442e",
    "#19b288",
    "#fd1ca1",
    "#35b8ce",
    "#1fba11",
    "#0d9d36",
    "#eb8fe9",
    "#e4fd41",
    "#9ea009",
    "#fd8ad4",
    "#414384",
    "#80f1fa",
    "#85a509",
    "#b31fe8",
    "#a43f16",
    "#43f9c2",
    "#a7d7e2",
    "#3700e2",
    "#9921ba",
    "#877185",
    "#5f7de1",
    "#0a265b",
    "#a742c8",
    "#bbee75",
    "#ddcde7",
    "#e43c21",
    "#e39635",
    "#7e5036",
    "#ae5523",
    "#333abe",
    "#b77702",
    "#52afdf",
    "#27c446",
    "#a5d195",
    "#a4c669",
    "#7f2a0d",
    "#ec4c2d",
    "#93fbce",
    "#c0c79e",
    "#09a76f",
    "#e54e92",
    "#92b562",
    "#23e7fe",
    "#102ae9",
    "#dfa623",
    "#8e9a28",
    "#f4646c",
    "#a571c2",
    "#67a31d",
    "#8c510e",
    "#4ece6a",
    "#94033a",
    "#365c70",
    "#f92fce",
  ];

  const renderLegend = () => {
    return (
      // <Card className={classes.cardapi}>
      //   <List>
      // <div>
      <Grid container>
        {serviceContext.data.map((entry, index) => (
          <Fragment key={`item-${index}`}>
            {serviceContext.data[index - 1] &&
            serviceContext.data[index - 1].category ===
              entry.category ? null : (
              <Grid item xs={12} style={{ marginTop: 8 }}>
                {size ? null : (
                  <Typography className={classes.servicetype} style={{}}>
                    {entry.category.charAt(0).toUpperCase()}
                    {entry.category.slice(1)} API
                  </Typography>
                )}
              </Grid>
            )}
            {size ? null : (
              <Grid item xs={3}>
                <FaCircle
                  size={10}
                  style={{ color: color[index], paddingRight: 5 }}
                />
                <Typography variant="caption" component="span">
                  {entry.name}
                </Typography>
              </Grid>
            )}

            {/* <div
              style={{
                display: "flex",
                // width: "100%",
                // justifyContent: "center",
                // alignItems: "center",
              }}
            >
              <FaCircle
                size={10}
                style={{ color: color[index], paddingRight: 5 }}
              />
              <Typography variant="caption" component="span">
                {entry.name}
              </Typography>
               <ListItem style={{ paddingLeft: 0, paddingRight: 0 }}>
                <ListItemText
                  primary={entry.name}
                  disableTypography
                  className={classes.listname}
                />
              </ListItem> 
            </div> */}
          </Fragment>
        ))}
      </Grid>

      // </div>
      //   </List>
      // </Card>
    );
  };

  const detailColumn = [
    {
      title: lang.API,
      field: "service",
      sorting: false,
      width: "fit-content",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
        borderRight: "1px solid #e7e7e7",
      },
    },
    {
      title: lang.Date,
      field: "date",
      sorting: false,
      width: "fit-content",
      cellStyle: {
        textAlign: "center",
        borderRight: "1px solid #e7e7e7",
        borderBottom: "unset",
      },
    },
    {
      title: lang.Time,
      field: "time",
      sorting: false,
      width: "fit-content",
      cellStyle: {
        textAlign: "center",
        borderRight: "1px solid #e7e7e7",
        borderBottom: "unset",
      },
    },
    {
      title: lang.UserName,
      field: "user",
      sorting: false,
      width: "fit-content",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        borderRight: "1px solid #e7e7e7",
        textAlign: "left",
        borderBottom: "unset",
      },
    },
    {
      title: lang.Keyname,
      field: "key",
      sorting: false,
      width: "fit-content",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        borderRight: "1px solid #e7e7e7",
        textAlign: "left",
        borderBottom: "unset",
      },
    },
    {
      title: lang.Request,
      field: "request",
      sorting: false,
      width: "fit-content",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderBottom: "unset",
      },
    },
  ];

  const rename = (s_id) => {
    let name = serviceContext.data.find((rs) => {
      return rs._id === s_id;
    });

    return name;
  };

  const convertDate = (d) => {
    const monthNames = [
      lang.January,
      lang.February,
      lang.March,
      lang.April,
      lang.May,
      lang.June,
      lang.July,
      lang.August,
      lang.September,
      lang.October,
      lang.November,
      lang.December,
    ];

    let dateObj = new Date(d);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, "0");
    let year = dateObj.getFullYear();

    let output = `${day} ${month} ${
      langContext.lang.locale === "th" ? Number(year + 543) : year
    }`;
    return output;
  };

  const convertTime = (d) => {
    return new Date(d).toLocaleTimeString();
  };

  const convertName = (id) => {
    let name = userContext.data.find((rs) => {
      return rs._id === id;
    });
    return name;
  };

  const convertNameAPI = (id) => {
    let name = apiContext.data.find((rs) => {
      return rs._id === id;
    });
    return name;
  };
  const detailData = () => {
    let arr = sum
      .sort((a, b) => {
        return a._id.datetime_ref > b._id.datetime_ref ? -1 : 1;
      })
      .map((rs) => {
        return {
          service:
            rename(rs._id.service_id) !== undefined
              ? rename(rs._id.service_id).name
              : "-",
          date: convertDate(rs._id.datetime_ref),
          time: convertTime(rs._id.datetime_ref),
          user:
            convertName(rs._id.user_id) !== undefined
              ? `${convertName(rs._id.user_id).first_name} ${
                  convertName(rs._id.user_id).last_name
                }`
              : "-",
          key:
            convertNameAPI(rs._id.apikey_id) !== undefined
              ? convertNameAPI(rs._id.apikey_id).app_name
              : "-",
          request: rs.sum_req_err > 0 ? lang.Error : lang.Success,
        };
      });
    return arr;
  };

  useEffect(() => {
    if (!fetch) {
      setfetch(true);
      setloading(true);
      setTimeout(() => {
        setloading(false);
      }, 1000);
    }
  }, [fetch, setloading]);

  const Nodata = [{ name: lang.NotFound }];

  const renderTooltip = (props) => {
    let { payload } = props;
    if (props.active) {
      return (
        <Card className={classes.cardtooltip}>
          <List>
            <ListItem>
              <Grid container>
                <Grid item xs={12}>
                  <Typography className={classes.fontlabel}>
                    {props.label}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
            {payload.map((entry, index) => {
              return (
                <ListItem key={`${entry.dataKey}_${index}`}>
                  <Grid container>
                    <Grid
                      item
                      xs={10}
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <FaCircle
                        color={entry.color}
                        size={10}
                        style={{ marginRight: "0.5rem" }}
                      />
                      <Typography className={classes.fonttooltip} align="left">
                        {rename(entry.dataKey)
                          ? rename(entry.dataKey).name
                          : "-"}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Typography className={classes.fonttooltip}>
                        {entry.value.toLocaleString()}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        </Card>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={type === "all" ? classes.search : classes.nosearch}>
      {type === "all" ? null : (
        <Tooltips title="กราฟแสดงการใช้งาน API" placement="top-start">
          <Typography
            style={{
              fontSize: "1rem",
              fontWeight: 700,
              color: "#595A5A",
            }}
          >
            {lang.APIUsage}
          </Typography>
        </Tooltips>
      )}
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      ) : (
        <div>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div style={{ width: "100%", height: 320 }}>
                <ResponsiveContainer>
                  <LineChart
                    layout="horizontal"
                    data={data.length ? data : Nodata}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeLinecap="round" />
                    <XAxis dataKey="name" type="category" />
                    <YAxis type="number" />
                    <Tooltip
                      content={renderTooltip}
                      wrapperStyle={{ zIndex: 1000, pointerEvents: "auto" }}
                    />
                    <Line
                      key={"notfound"}
                      dataKey={"value"}
                      stroke={color[0]}
                      strokeWidth={2}
                    />
                    {serviceContext.data.map((rs, index) => {
                      return (
                        <Line
                          key={rs._id}
                          dataKey={rs._id}
                          stroke={color[index]}
                          strokeWidth={2}
                        />
                      );
                    })}
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div id="symbol">{renderLegend()}</div>
            </Grid>
            <Grid item xs={12} className={classes.grid}>
              {type === "all" ? null : (
                <Tooltips
                  title={
                    expand
                      ? "คลิกเพื่อซ่อนรายละเอียด"
                      : "คลิกเพื่อแสดงรายละเอียดเพิ่มเติม"
                  }
                  placement="top"
                >
                  <Button
                    className={classes.btnstyle}
                    endIcon={
                      expand ? (
                        <FaCaretUp className={classes.icon} />
                      ) : (
                        <FaCaretDown className={classes.icon} />
                      )
                    }
                    onClick={() => {
                      setExpand(!expand);
                    }}
                  >
                    {lang.Moredetail}
                  </Button>
                </Tooltips>
              )}
            </Grid>
          </Grid>
          <Collapse in={expand} timeout="auto" unmountOnExit>
            <TableData
              columns={detailColumn}
              data={detailData()}
              Iconsort={React.forwardRef((props, ref) => (
                <FaSort {...props} ref={ref} />
              ))}
            />
            {expand ? (
              <div style={{ margin: "0rem 2rem" }}>
                <Card className={classes.cardnote}>
                  <div style={{ margin: "1rem" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Typography style={{ color: "#595A5A" }}>
                        กรณีการร้องขอผิดพลาด
                      </Typography>
                      <Typography
                        color="error"
                        style={{ marginLeft: "0.5rem" }}
                      >
                        ***
                      </Typography>
                    </div>
                    {errorcomment.map((rs, i) => {
                      return (
                        <div
                          key={i}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <FaCircle
                            size={8}
                            color="#E16733"
                            style={{
                              marginRight: "0.5rem",
                              marginLeft: "0.5rem",
                            }}
                          />
                          <Typography
                            style={{ fontWeight: 400, color: "#595A5A" }}
                          >
                            {rs.title}
                          </Typography>
                        </div>
                      );
                    })}
                  </div>
                </Card>
              </div>
            ) : null}
          </Collapse>
        </div>
      )}
    </div>
  );
};

export default Linechartapi;
